import { Component, OnInit, Output, Input, EventEmitter, ChangeDetectorRef,  } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { GetyourguideOffer } from '@app/models/offerpack/GetyourguideOffer';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'clever-getyourguide-detail',
    templateUrl: './getyourguide-detail.component.html',
    styleUrls: ['./getyourguide-detail.component.scss'],
    standalone: false
})
export class GetyourguideDetailComponent implements OnInit {
    @Input() datas: GetyourguideOffer;
    @Output() sendReg: EventEmitter<boolean> = new EventEmitter();
    private unsubscribe$ = new Subject();

    deskMode: boolean = true;

    curentContent: number = 0;

    constructor(
        protected mediaObserver: BreakpointObserver,
        private cdr: ChangeDetectorRef
    ) {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.deskMode = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.deskMode = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.deskMode = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.deskMode = true;
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.deskMode = true;
        }
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    sendAnmeldung() {
        this.sendReg.emit(true);
    }
}
